export default __webpack_public_path__ + "static/hackathon-grid-6-38d56eec719c3fbc0cfb4698b8ba5864.png";